import { Box } from "@biblioteksentralen/react";
import { useTranslation } from "../../utils/hooks/useTranslation";
import BlockContent from "../blockContent/BlockContent";
import { ResolvedRecommendation } from "@libry-content/common";

export const RecommendationDescription = ({ recommendation }: { recommendation: ResolvedRecommendation }) => {
  const { ts } = useTranslation();
  return (
    <Box
      css={{
        "div p": {
          maxWidth: "inherit",
          margin: "0 0 1rem 0",
          "&:last-child": {
            margin: 0,
          },
        },
      }}
    >
      <BlockContent fontSize="lg" blocks={ts(recommendation.description)} />
    </Box>
  );
};
